import axios from 'axios'
import { initShopeepayReporter, instrumentAxios } from '@shopeepay/reporter'

initShopeepayReporter({ region: 'my', project: 'shopeepay-my' })
instrumentAxios(axios, 'shopeepay-my')
